import React, {Component} from 'react';
import { connect } from 'dva';
import { Form, Modal, Popover, Button, Spin, Row, Col } from 'antd';
import moment from 'moment';
import Request from 'superagent';
import FormComponent from '../../../components/FormComponent';
import config from '../config/config';

class ServiceSelector extends FormComponent {
  constructor(props) {
    super(props);

    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentWillMount() {
    /*
    const {dispatch, meta} = this.props;

    moment.locale('ja-JP');
    const url = meta.url;
    const self = this;

    if(url) {
      Request
        .get(url)
        .type('json')
        .then(Dimio.apiResponse)
        .then(response => {
          dispatch({
            type: 'meta/setNews',
            news: response.body
          });
          self.setState({loading:false});
        })
        .catch(err => {
          throw err
        });
    }else{
      throw "URL is not specified";
    }
    */
  }
  handleSubmit(e) {
    e.preventDefault();
  }

  render() {
    //const {meta} = this.props;
    const {fields} = config;

    const ExtendField = (props) => {
      const Field = this.Field;
      return(
        <div>
          <Field
            {...props.fields}
            className="py-3 px-3"
          />
          {props.children}
        </div>
      );
    }


    return (
      <section>
        <Form onSubmit={this.handleSubmit}>
          <ExtendField fields={fields.product_type}>
            {/*
            <Radio.Group className="d-block" onChange={(e) => this.onSelectProductType(e.target.value)}>
              <Row gutter={8}>
                {fields.product_type.items.map((item) => (
                  <Col span={12} key={item.value}>
                    <Radio value={item.value} className="text-center">
                      {item.label}
                    </Radio>

                    <Tooltip placement="bottom" title={item.tip} trigger="click">
                      <button type="button" className="hint"><Icon type="question-circle" /></button>
                    </Tooltip>
                  </Col>
                ))}
              </Row>
            </Radio.Group>
*/}
          </ExtendField>
        </Form>
      </section>
    );
  }
}

export default connect(({ meta, mobile }) => ({
  meta, mobile
}))(ServiceSelector);


// WEBPACK FOOTER //
// ./src/pages/mobile/components/ServiceSelector.js